import React, { useEffect } from 'react';
import CaseStudysuccesbanner from './CaseStudysuccesbanner';
import CasestudiesInnvoationscards from './CasestudiesInnvoationscards';
import CasestudiesCards from './CasestudiesCards';
import CasestudiesSecondcards from './CasestudiesSecondcards';
import CaseStudiesSectionpage from './CaseStudiesSectionpage';
import Customersuccessstorycards from './Customersuccessstorycards';
const CasestudyCustomersuccestory = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // Empty dependency array ensures it only runs once when the component mounts
    // Scroll to the top of the page when the component mounts

    return (
        <div style={{ backgroundColor: '#fff' }}>
            <CaseStudysuccesbanner />
            <Customersuccessstorycards/>
            {/* <CaseStudiesSectionpage /> */}
            {/* <CasestudiesCards /> */}
            {/* <CasestudiesSecondcards /> */}

        </div>
    );
};

export default CasestudyCustomersuccestory;
